import * as ActionTypes from "../Types/ActionTypes";

export const NdmaParameter = (
  state = {
    isLoading: true,
    errMess: null,
    ndmaParameters: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_NDMAPARAMETERS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        ndmaParameters: action.payload,
      };

    case ActionTypes.NDMAPARAMETERS_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        ndmaParameters: [],
      };

    case ActionTypes.NDMAPARAMETERS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        ndmaParameters: [],
      };

    default:
      return state;
  }
};
